import { isBefore, parseISO, format, isEqual } from "date-fns"

export const combineDateAndTime = (inputDate, inputTime) => {
  if (typeof inputDate !== "undefined") {
    if (inputDate && inputTime) {
      const formattedDate = format(inputDate, "yyyy-MM-dd")
      const combinedResult = formattedDate + "T" + inputTime + ":00"

      return combinedResult
    }
  }
}

export const notFutureDatime = (inputDate, inputTime) => {
  if (inputDate && inputTime) {
    let formattedDateTime = parseISO(combineDateAndTime(inputDate, inputTime))
    return isBefore(formattedDateTime, new Date())
  }
}

export const convertStringToDecimal = amount => {
  if (amount) {
    return parseFloat(amount.toString().replace(/,/g, ""))
  }
}

export const isAfterDateTime = (startDate, startTime, endDate, endTime) => {
  if (startDate && startTime.length === 5 && endDate && endTime.length === 5) {
    let startDateTime = parseISO(combineDateAndTime(startDate, startTime))
    let endDateTime = parseISO(combineDateAndTime(endDate, endTime))

    return (
      isBefore(startDateTime, endDateTime) ||
      isEqual(startDateTime, endDateTime)
    )
  }
}
